<template>
    <el-header height="60px">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-for="(item,key) in breadcrumb" :key="key">
                <template v-if="item.url">
                    <router-link :to="item.url">{{item.name}}</router-link>
                </template>
                <template v-else>
                    {{item.name}}
                </template>
            </el-breadcrumb-item>
        </el-breadcrumb>
        <ul class="header-operations">
          <li><router-link to="/admin/multiple">站点列表</router-link></li>
          <el-divider direction="vertical"></el-divider>
            <li>{{user.phone_mob }}</li>
          <el-divider direction="vertical"></el-divider>
            <li><span class="header-lang" @click="logout">退出</span></li>
        </ul>
    </el-header>

</template>

<script>
    import Cookies from 'js-cookie'
    import Vue from "vue";
    export default {
        name: "my-header",
        props:{
            breadcrumb:Array
        },
        data() {
            return {
                userId:0,
                user:{}
            }
        },
        created() {

                this.userId = Cookies.get('user_id');
                this.$http.get('/v1/user/view',{params:{userId:this.userId}}).then((res)=>{
                    this.user = res.data;
                })

            /*this.breadcrumbData = this.$store.state.breadcrumb
            if (!this.breadcrumbData) {
                this.breadcrumbData = JSON.parse(sessionStorage.getItem('breadcrumb'))
                console.log(this.breadcrumbData)
            }*/
        },
        methods: {
            logout() {
                var _this = this;
                Cookies.remove('user_id',{domain:this.cookieDomain});
                Cookies.remove('access_token',{domain:this.cookieDomain});
                Cookies.remove('storeId',{domain:this.cookieDomain});
                /*this.$http.get(this.pcDomainUrl+'/?app=member&act=logout&ajax=1').then((res) => {
                    if (res.data.errcode == 0){
                        location.href = _this.pcLoginUrl;
                    }else {
                        location.href = _this.pcLoginUrl;
                    }
                });*/
              location.href = Vue.prototype.loginDomain + '/#/admin/login?redirectUrl=' + encodeURIComponent(location.href)
                //this.$router.push('/admin/login')
            }
        }
    }
</script>

<style scoped>
    .el-header{
        background: #fff;
        color: #666;
        line-height: 60px;
        border-bottom: 1px solid #ececec
    }
    .header-operations{
        padding:0;
    }
    .header-operations li{
        line-height: 60px;
        color: #666;
    }
    .header-operations li a{
      color: #666;
    }
    .el-breadcrumb{
        float: left;
        line-height: 60px;
        height: 60px;
    }
</style>
